<script setup lang="ts">
  import { computed } from 'vue'
  import { toPortalSearchHighlightSegments } from '~/utils/portalGlobalSearch'

  const props = defineProps<{
    text?: string
  }>()

  const segments = computed(() => toPortalSearchHighlightSegments(props.text))
</script>

<template>
  <template v-for="(segment, index) in segments" :key="index">
    <em
      v-if="segment.emphasized"
      class="rounded bg-amber-100 px-1 py-0.5 font-semibold not-italic text-amber-800"
    >
      {{ segment.text }}
    </em>
    <template v-else>{{ segment.text }}</template>
  </template>
</template>
